// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { firebaseConfig } from "./firebase-config";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

let _app;

export function initFirebase() {
  // Initialize Firebase
  _app = initializeApp(firebaseConfig);
  const analytics = getAnalytics(_app);
}

export function getDB() {
  return getFirestore(_app);
}

export function getClougStorage() {
  return getStorage();
}
